//@ts-ignore
import React, { useMemo, useCallback, useState, useEffect, useContext } from 'react';
import { VStack, HStack, Divider, Pressable, Spinner } from 'native-base';
import { Button, Badge, Typography, Iconography, logUserEvent } from 'fmc-digital-common';
import { TaskConstants } from '../../../constants';
import { useLipStore } from '../../../loaninprogress';
import { DocumentTable } from '../DocTable';
import { ESignContext, getToken } from '../../../loaninprogress/hooks/Esign';
import DocUploadTrackingSnackbar from '../DocUploadTrackingSnackbar';
export default (({
  item,
  index,
  handleToggle,
  selectedCard
}) => {
  const {
    setShowDocUploadModal: onShowDocModal,
    setTaskName,
    setTrackingItemName,
    setShowDocUploadModalWeb,
    clearSelectedFiles
  } = useLipStore(state => state);
  const isOpen = selectedCard === index;
  const {
    name,
    taskStatus,
    taskType,
    details,
    isWaitingforBorrowerESign,
    nonEsignedBorrowerNames,
    borrowerName,
    documentList,
    trackingItemName,
    status
  } = item;
  const {
    TASK_TYPE_TRACKING_ITEM,
    TASK_STATUS_COMPLETED,
    ACTIONS_SIGN_DISCLOSURES,
    ACTIONS_UPLOAD,
    WAITING_FOR_TEXT,
    TASK_TYPE_SIGN_DISCLOSURES,
    TASK_UPLOAD_ERROR_CORRECTION_NEEDED,
    TASK_UPLOAD_ERROR_PRE_GATE_INCOMPLETE,
    TASK_UPLOAD_ERROR_PROBLEM,
    TASK_UPLOAD_ERROR_MESSAGE
  } = TaskConstants;
  const buttonText = taskType === TASK_TYPE_TRACKING_ITEM ? taskStatus === TASK_STATUS_COMPLETED ? '' : ACTIONS_UPLOAD : taskStatus === TASK_STATUS_COMPLETED && isWaitingforBorrowerESign ? '' : taskStatus === TASK_STATUS_COMPLETED ? '' : ACTIONS_SIGN_DISCLOSURES;
  const iconType = taskType === TASK_TYPE_TRACKING_ITEM ? 'UploadIcon' : 'SignIcon';
  const [isTokenWaiting, setTokenWaiting] = useState(false);
  const [selectedDisclosureUserName, setSelectedDisclosureUserName] = useState('');
  //@ts-ignore
  const {
    refetchInterval,
    setRefetchInterval,
    loanNumber,
    url,
    authToken,
    handleOnTokenResponse,
    isEsignUpdating,
    xApiKey,
    activeDisclosedUserName,
    esignStatusDetails: {
      infoData,
      errorData,
      isEnabledEsign,
      esignStatusMessage
    }
  } = useContext(ESignContext);
  const isESignPackage = taskType == TASK_TYPE_SIGN_DISCLOSURES ? true : false;
  const docList = useMemo(() => documentList && documentList?.map(({
    documentName,
    createdDate
  }) => ({
    documentName,
    createdDate
  })) || [], [documentList]);

  //@ts-ignore
  const renderIcon = useMemo(() => {
    switch (iconType) {
      case 'UploadIcon':
        return /*#__PURE__*/React.createElement(Iconography, {
          name: "upload",
          size: 21,
          color: "blue.900"
        });
      case 'SignIcon':
        return /*#__PURE__*/React.createElement(Iconography, {
          name: "edit",
          size: 21,
          color: "blue.900"
        });
      default:
        break;
    }
  }, [iconType]);
  const badgeVariant = useMemo(() => {
    switch (taskStatus) {
      case 'To Do':
        return 'warning';
      case 'Completed':
        return 'success';
      default:
        return 'review';
    }
  }, [taskStatus]);
  const onUploaderESignButtonClick = useCallback(() => {
    if (iconType === 'UploadIcon') {
      clearSelectedFiles();
      onShowDocModal(true);
      setShowDocUploadModalWeb(true);
      setTaskName(`${name}`);
      setTrackingItemName(trackingItemName);
      logUserEvent({
        action: 'UploadClicked',
        type: 'LIPDocUploadTask',
        description: `Task Section Doc Upload Task ${name}`
      });
    } else {
      logUserEvent({
        action: 'SignDisclosuresClicked',
        type: 'LIPSignDisclosureTask',
        description: `Task Section Sign Disclosure Task ${item.borrowerName}`
      });
      //@ts-ignore
      getToken(item);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getToken, iconType, item, name, onShowDocModal, setTaskName, setTrackingItemName, trackingItemName, setShowDocUploadModalWeb, clearSelectedFiles]);
  const onEsignButtonClick = async () => {
    setSelectedDisclosureUserName(item?.borrowerName || '');
    setTokenWaiting(true);
    logUserEvent({
      action: 'SignDisclosuresClicked',
      type: 'LIPSignDisclosureTask',
      description: `Task Section Sign Disclosure Task ${item?.borrowerName}`
    });
    await getToken(item, handleTokenResponse, loanNumber, authToken, url, xApiKey);
    setTokenWaiting(false);
  };
  useEffect(() => {
    if (isEsignUpdating) {
      setRefetchInterval(5000);
      const activeUser = activeDisclosedUserName || '';
      setSelectedDisclosureUserName(activeUser);
      //setEsignUpdating(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEsignUpdating, activeDisclosedUserName]);
  const handleTokenResponse = useCallback(({
    token,
    url,
    activeDisclosedUserName
  }) => {
    logUserEvent({
      action: 'OpeningDocuTech',
      type: 'ESign'
    });
    handleOnTokenResponse(token, url, activeDisclosedUserName);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [handleOnTokenResponse, logUserEvent]);
  const showTaskUploadWarning = status === TASK_UPLOAD_ERROR_PROBLEM || status === TASK_UPLOAD_ERROR_PRE_GATE_INCOMPLETE || status === TASK_UPLOAD_ERROR_CORRECTION_NEEDED;
  const displayMessage = useMemo(() => {
    return showTaskUploadWarning || esignStatusMessage && taskType === TASK_TYPE_SIGN_DISCLOSURES ? /*#__PURE__*/React.createElement(DocUploadTrackingSnackbar, {
      taskUploadErrorMessage: showTaskUploadWarning ? TASK_UPLOAD_ERROR_MESSAGE : esignStatusMessage,
      infoData: infoData,
      errorData: errorData
    }) : null;
  }, [showTaskUploadWarning, esignStatusMessage, TASK_UPLOAD_ERROR_MESSAGE, infoData, errorData]);
  return /*#__PURE__*/React.createElement(VStack, {
    testID: "TaskCard",
    bg: isOpen ? 'lightBlue.200' : index % 2 === 0 ? 'white.500' : 'white.800',
    borderColor: "lightBlue.400",
    borderRadius: 4,
    shadow: 4,
    borderWidth: 1,
    p: 4,
    mb: 2
  }, /*#__PURE__*/React.createElement(VStack, {
    borderRadius: 4,
    space: 4
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: 'space-between'
  }, /*#__PURE__*/React.createElement(HStack, {
    maxW: {
      md: '43',
      base: '34',
      sm: '55',
      lg: '55',
      xl: '55'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    testID: "TaskName",
    variant: "regularBold",
    color: "darkGray.900",
    accessibilityLabel: `taskname${name}`,
    accessibilityRole: "text"
  }, name)), taskStatus ? /*#__PURE__*/React.createElement(Badge, {
    testID: "TaskBadgeStatus",
    variant: badgeVariant,
    _text: {
      color: `${taskStatus === 'To Do' ? 'darkGray.900' : 'white.500'}`
    },
    h: 8,
    accessibilityLabel: `taskstatus${taskStatus}`,
    accessibilityRole: "text"
  }, taskStatus) : null), details ? /*#__PURE__*/React.createElement(Typography, {
    variant: "caption13",
    color: "review.500",
    testID: "task-error-info-message"
  }, taskType === TASK_TYPE_SIGN_DISCLOSURES ? TaskConstants.EsignInfoMessage : details) : null, displayMessage, borrowerName ? /*#__PURE__*/React.createElement(HStack, {
    testID: "TaskUserInfo",
    id: "name",
    alignItems: 'center',
    space: "5px"
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: "person",
    size: 20,
    color: "blue.900"
  }), /*#__PURE__*/React.createElement(Typography, {
    testID: "BorrowerName",
    variant: "regularBold",
    color: "darkGray.900",
    accessibilityLabel: `borrowername${borrowerName}`,
    accessibilityRole: "text"
  }, borrowerName)) : null, taskType === TASK_TYPE_TRACKING_ITEM ? /*#__PURE__*/React.createElement(HStack, {
    justifyContent: 'space-between',
    w: '100%'
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: "attach-file",
    size: 21,
    color: "blue.900"
  }), /*#__PURE__*/React.createElement(Typography, {
    testID: "DocumentList",
    variant: "caption13",
    color: "darkGray.900",
    accessibilityLabel: `filesuploaded${documentList?.length}`,
    accessibilityRole: "text"
  }, documentList && documentList?.length > 0 ? `${documentList.length} files uploaded` : 'None')), documentList && documentList?.length > 0 ? /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => handleToggle(index, name)
  }, isOpen ? /*#__PURE__*/React.createElement(Iconography, {
    name: "keyboard-arrow-down",
    size: 24,
    color: "primary.500"
  }) : /*#__PURE__*/React.createElement(Iconography, {
    name: "keyboard-arrow-up",
    size: 24,
    color: "primary.500"
  })) : null) : null, isOpen ? /*#__PURE__*/React.createElement(DocumentTable, {
    docTableList: docList
  }) : null, buttonText ? /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Divider, {
    orientation: 'horizontal',
    height: "1",
    borderRadius: "1",
    bg: "lightBlue.200"
  }), isESignPackage ? selectedDisclosureUserName == item.borrowerName && (isTokenWaiting || !!refetchInterval) ? /*#__PURE__*/React.createElement(Spinner, {
    accessibilityLabel: "Loading",
    color: "blue.900",
    size: "lg",
    alignItems: 'flex-end',
    mt: '2'
  }) : /*#__PURE__*/React.createElement(Button, {
    testID: "TaskButton",
    width: 'auto',
    alignSelf: 'flex-end',
    startIcon: renderIcon,
    variant: 'ghost',
    accessibilityLabel: `${buttonText}click`,
    accessibilityRole: "button",
    onPress: onEsignButtonClick,
    isDisabled: !isEnabledEsign,
    isLoading: isTokenWaiting
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "regularBold",
    color: "blue.900",
    textTransform: 'uppercase'
  }, buttonText)) : /*#__PURE__*/React.createElement(Button, {
    testID: "TaskButton",
    isLoading: false,
    width: 'auto',
    alignSelf: 'flex-end',
    startIcon: renderIcon,
    variant: 'ghost',
    accessibilityLabel: `${buttonText}click`,
    accessibilityRole: "button",
    onPress: onUploaderESignButtonClick
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "regularBold",
    color: "blue.900",
    textTransform: 'uppercase'
  }, buttonText))) : isWaitingforBorrowerESign ? /*#__PURE__*/React.createElement(HStack, {
    space: "4",
    alignItems: "center",
    justifyContent: {
      base: 'flex-end',
      md: 'flex-end',
      lg: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: "group",
    size: 20,
    color: "primary.500"
  }), /*#__PURE__*/React.createElement(VStack, {
    borderRadius: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "regularBold",
    color: "review.500",
    accessibilityLabel: `${WAITING_FOR_TEXT}`,
    accessibilityRole: "text"
  }, WAITING_FOR_TEXT), /*#__PURE__*/React.createElement(Typography, {
    variant: "regular",
    color: "review.500",
    textTransform: "uppercase",
    accessibilityLabel: `${nonEsignedBorrowerNames}`,
    accessibilityRole: "text"
  }, nonEsignedBorrowerNames ? nonEsignedBorrowerNames.replace(/(\r\n|\n|\r)/gm, '') : ''))) : null));
});
//# sourceMappingURL=TaskCard.js.map